import React from 'react'

import './SellingStartsSlide.scss'

export const SellingStartsSlide = (): React.ReactElement => {
  return (
    <div className="slide-container">
      <div className="consumerImage" />
      <h1 className="header-consumer-1 mt-4 mb-2">Selling starts with knowledge</h1>
      <p className="subheader-consumer-1">
        Get to know your customers so you can offer them what they need, when they need it.
      </p>
      <p className="text-sm text-inactive productConsumer">gfknewron Consumer</p>
    </div>
  )
}
